export default "__VITE_ASSET__6316442b__"